import axios from 'axios';

const API_URL = process.env.API_URL || 'https://dev-api-neptune.eeven.fr';

const apiClient = axios.create({
    baseURL: API_URL,
});

// Intercepteur de requête : ajoute le token sur chaque requête
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Récupère le token à la demande
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Intercepteur de réponse : gère les erreurs 401 (token expiré)
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
            window.location.href = '/login';
            localStorage.removeItem('token');
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default apiClient;